import { SimpleGrid, Container } from "@mantine/core";
import classes from "./ServicesFeaturesWhy.module.css";
import cert from "../../images/cert.jpg";
import { useTranslation } from "react-i18next";
import { ServicesFeatureWhy } from "./ServicesFeaturesWhy";

export function ServicesEthicalFinancing() {
  const { t } = useTranslation();

  const mockdata = [
    {
      image: cert,
    },
    {
      title: t("services.section3bTitle"),
      description: t("services.section3bDescription"),
    },
  ];

  const items = mockdata.map((item, index) => (
    <ServicesFeatureWhy {...item} key={index} />
  ));

  return (
    <Container mt={0} mb={0} size="full" className={classes.featuresContainer}>
      <SimpleGrid cols={{ base: 1, sm: 2, md: 2, lg: 2 }} spacing={10}>
        {items}
      </SimpleGrid>
    </Container>
  );
}
